import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fvjocckztcchvgyudsyu.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ2am9jY2t6dGNjaHZneXVkc3l1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg2MTYwMDQsImV4cCI6MjA2NDE5MjAwNH0.Lr9ArkY44XW6yelvpN0Xws-bc6GOTa4-JDg_rHpk82Q';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
